var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 5.04163L17.3069 14.2313C17.1617 16.5792 17.0892 17.7531 16.5007 18.5972C16.2097 19.0145 15.8351 19.3667 15.4006 19.6313C14.5219 20.1666 13.3457 20.1666 10.9933 20.1666C8.63786 20.1666 7.46011 20.1666 6.5808 19.6303C6.14607 19.3652 5.77133 19.0124 5.48046 18.5944C4.89214 17.749 4.82116 16.5734 4.67923 14.2222L4.125 5.04163",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 5.04171H19.25M14.7177 5.04171L14.092 3.75079C13.6763 2.89328 13.4684 2.46452 13.1099 2.19712C13.0304 2.1378 12.9462 2.08504 12.8581 2.03935C12.4611 1.83337 11.9846 1.83337 11.0316 1.83337C10.0547 1.83337 9.56633 1.83337 9.16271 2.04798C9.07326 2.09555 8.9879 2.15045 8.90752 2.21211C8.54484 2.49035 8.34224 2.93479 7.93706 3.8237L7.38184 5.04171",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70825 15.125V9.625",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2917 15.125V9.625",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.f5e0554461ee0b5db8d0b8484a93ba3a.svg";
export { ForwardRef as ReactComponent };